import { Button, ButtonGroup, DropdownButton, DropdownMenuItem } from "@mixitone/components";
import ClubIcon from "@mixitone/icons/club.svg";
import { ApplicationView } from "@mixitone/mvc";
import { family } from "@tauri-apps/plugin-os";
import clsx from "clsx";
import { AppController } from "controllers/AppController";
import tauri from "lib/tauri";

const ClubMenu = () => {
  const appController = AppController.use();
  const { currentClub, clubs } = appController.state;
  const windowsChevronSpacing = (() => {
    if (!tauri.enabled) return false;
    try {
      return family() === "windows";
    } catch {
      return false;
    }
  })();

  return (
    <ButtonGroup>
      {currentClub && (
        <Button
          kind="topNav"
          title="Go to club"
          onClick={() => {
            appController.actionForward("/clubs/:clubId", {
              params: { clubId: currentClub.id! },
              viewTransition: true,
            });
          }}
          className="stroke-gray-300 @sm/app:block"
          style={{ height: "var(--mixitone-header-height)" }}
        >
          <ClubIcon className="w-4 h-4 stroke-white fill-white" />
        </Button>
      )}
      <DropdownButton
        buttonProps={{
          kind: "select",
          "aria-label": "Select club",
          className: clsx(
            "bg-slate-800 text-white hover:bg-slate-700 border-0 cursor-pointer inline-flex items-center justify-center whitespace-nowrap stroke-gray-300 [&>span:last-child>svg]:fill-white [&>span:last-child>svg>path]:fill-white group-hover:bg-slate-700",
            windowsChevronSpacing ? "pl-3 pr-9" : "pl-0.5 pr-7",
          ),
          style: { height: "var(--mixitone-header-height)" },
          "data-testid": "club-dropdown",
        }}
        button={currentClub?.name ?? "Select club"}
        arrow
      >
        {clubs.map((club) => (
          <DropdownMenuItem
            key={`club-dropdown-item-${club.id}`}
            closeOnClick
            className={clsx({
              "bg-brand-200": currentClub?.id === club.id,
            })}
            onClick={() => {
              appController.actionSetCurrentClub(club);
            }}
          >
            {club.name}
          </DropdownMenuItem>
        ))}
      </DropdownButton>
    </ButtonGroup>
  );
};

export default ApplicationView(ClubMenu);
